import { baseApi, extractData } from "../api/axiosConfig";


export const getAllContractSections = () =>
    baseApi
        .get("/contractSection")
        .then(extractData);


export const addContractSection = data =>
    baseApi
        .post("/contractSection", data)
        .then(extractData);


export const editContractSection = (contractSectionId, data) =>
    baseApi
        .put(`/contractSection/${contractSectionId}`, data)
        .then(extractData);


export const deleteContractSection = contractSectionId =>
    baseApi
        .delete(`/contractSection/${contractSectionId}`)
        .then(extractData);


export const getNewCS = () =>
    baseApi
        .get("/contractSection/newCS")
        .then(extractData);

export const getContractSectionById = contractSectionId =>
    baseApi
        .get(`/contractSection/${contractSectionId}`)
        .then(extractData);

export const getContractSectionByContractId = contractId =>
    baseApi
        .get("/contractSection", {
            params: {
                contractId
            }
        })
        .then(extractData);

export const getContractCS = contractId =>
    baseApi
        .get("/contractSection/contractCS", {
            params: {
                contractId
            }
        })
        .then(extractData);


export const updateCsTree = () =>
    baseApi
        .get("/contractSection/updateCsTree")
        .then(extractData);


export const cloneSectionContents = (
    sourceSectionId,
    destinationSectionId,
    maximumCdp,
    minimumCdp,
    includeFilters
) =>
    baseApi
        .get("/contractSection/clone", {
            params: {
                source_section_id: sourceSectionId,
                destination_section_id: destinationSectionId,
                maximum_cdp: maximumCdp,
                minimum_cdp: minimumCdp,
                include_filters: includeFilters
            }
        })
        .then(extractData);


export const moveContractSection = (contractSectionId, moveDirection) =>
    baseApi
        .get("/contractSection/moveContractSection", {
            params: {
                my_contract_section_id: contractSectionId,
                move_direction: moveDirection
            }
        })
        .then(extractData);


export const deleteMasterContractSection = contractSectionId =>
    baseApi
        .get("/contractSection/deleteMasterContractSection", {
            params: {
                my_contract_section_id: contractSectionId
            }
        })
        .then(extractData);


export const populateDashboard = dashboardSectionId =>
    baseApi
        .get("/contractSection/populateDashboard", {
            params: {
                my_dashboard_section_id: dashboardSectionId
            }
        })
        .then(extractData);


export const getDashboardVersions = dashboardSectionId =>
    baseApi
        .get("/contractSection/dashboardVersions", {
            params: {
                my_dashboard_section_id: dashboardSectionId
            }
        })
        .then(extractData);


export const repeatBranch = originalSectionId =>
    baseApi
        .get("/contractSection/repeatBranch", {
            params: {
                original_cs_id: originalSectionId
            }
        })
        .then(extractData);


export const repeatBranchFresh = originalSectionId =>
    baseApi
        .get("/contractSection/repeatBranchFresh", {
            params: {
                original_cs_id: originalSectionId
            }
        })
        .then(extractData);


export const reinsertBranch = originalSectionId =>
    baseApi
        .get("/contractSection/reinsertBranch", {
            params: {
                original_cs_id: originalSectionId
            }
        })
        .then(extractData);


export const regrowBranch = originalSectionId =>
    baseApi
        .get("/contractSection/regrowBranch", {
            params: {
                original_cs_id: originalSectionId
            }
        })
        .then(extractData);


export const trimBranch = originalSectionId =>
    baseApi
        .get("/contractSection/trimBranch", {
            params: {
                original_cs_id: originalSectionId
            }
        })
        .then(extractData);


export const updateCsTreeByContractId = contractId =>
    baseApi
        .get("/contractSection/updateCsTreeByContractId", {
            params: {
                contract_id: contractId
            }
        })
        .then(extractData);


export const updateContractSectionContents = (contractSectionId, contents) =>
    baseApi
        .patch(`/contractSection/${contractSectionId}/contents`, {
            contents
        })
        .then(extractData);


export const updateLineItem = contractSectionId =>
    baseApi
        .get("/contractSection/updateLineItem", {
            params: {
                my_section_id: contractSectionId
            }
        })
        .then(extractData);


export const getHelperData = contractSectionId =>
    baseApi
        .get("/contractSection/helperData", {
            params: {
                my_contract_section_id: contractSectionId
            }
        })
        .then(extractData);



export const getHelperItems = contractSectionId =>
    baseApi
        .get("/contractSection/helperItems", {
            params: {
                my_item_section: contractSectionId
            }
        })
        .then(extractData);


export const graftSection = (
    sourceSectionId,
    parentSectionId,
    previousSectionId
) =>
    baseApi
        .get("/contractSection/graft", {
            params: {
                original_cs_id: sourceSectionId,
                target_parent_cs_id: parentSectionId,
                target_previous_cs_id: previousSectionId
            }
        })
        .then(extractData);


// export const updateNameByLabel = myCdpvIds  =>
//     baseApi
//         .get("/contractSection/updateNameByLabel", {
//             params: {
//                 my_cdpv_ids: myCdpvIds
//             }
//         })
//         .then(extractData);

// export const updateNameByLabel = myCdpvIds =>
//     baseApi
//         .get("/contractSection/updateNameByLabel", {
//             params: {
//                 my_cdpv_ids: myCdpvIds
//             },
//             paramsSerializer: {
//                 indexes: null
//             }
//         })
//         .then(extractData);

export const updateNameByLabel = myCdpvIds =>
    baseApi
        .get("/contractSection/updateNameByLabel", {
            params: {
                my_cdpv_ids: myCdpvIds
            },
            paramsSerializer: params => {
                const searchParams = new URLSearchParams();

                params.my_cdpv_ids.forEach(id => {
                    searchParams.append("my_cdpv_ids", id);
                });

                return searchParams.toString();
            }
        })
        .then(extractData);

// import axios from "axios";
//
// const BASE_URL = import.meta.env.VITE_BACKEND_URL;
//
// export const getAllContractSections = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSection`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export   const addContractSection = abcd =>
//     axios.post(`${BASE_URL}/api/contramatic/contractSection`, abcd, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const editContractSection = (selectorContractSectionId, data) =>
//     axios.put(`${BASE_URL}/api/contramatic/contractSection/${selectorContractSectionId}`, data, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// //https://www.javatpoint.com/react-axios-delete-request-example except that it shows the wrong kinds of quotes - not backquotes
// export const deleteContractSection = selectorContractSectionId =>
//     axios.delete(`${BASE_URL}/api/contramatic/contractSection/${selectorContractSectionId}`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
// //
// //
// // export const getThisContractsSections = () =>
// //     fetch("api/contramatic/contractSection")
// //         .then(checkStatus);
//
//
//
//
// export const getNewCS = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSection/newCS`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getContractSectionById = (contractSectionIdX) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSection/${contractSectionIdX}`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getContractSectionByContractId = (contractId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSection?contractId=${contractId}`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getContractCS = (contractId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSection/contractCS`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {contractId: contractId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
//
//
// export const updateCsTree = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSection/updateCsTree`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const cloneSectionContents = (source_section_id, destination_section_id, maximum_cdp, minimum_cdp,include_filters ) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSection/clone`,
//                 {
//                     headers: {
//                         'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//                     },
//                     params: {
//                         source_section_id: source_section_id,
//                 destination_section_id: destination_section_id,
//                         maximum_cdp: maximum_cdp,
//                         minimum_cdp: minimum_cdp,
//                         include_filters: include_filters
//         }}
//     )
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log("submission fields")
//             console.log(source_section_id, destination_section_id, minimum_cdp, maximum_cdp)
//             console.log(error.config);
//         })
//
// export const moveContractSection = (myContractSectionId, moveDirection) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSection/moveContractSection`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_contract_section_id: myContractSectionId,
//                 move_direction: moveDirection,
//             }
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
//
// export const deleteMasterContractSection = (myContractSectionId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSection/deleteMasterContractSection`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_contract_section_id: myContractSectionId
//             }
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const populateDashboard = (myContractSectionId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSection/populateDashboard`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_dashboard_section_id: myContractSectionId
//             }
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getDashboardVersions = (myContractSectionId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSection/dashboardVersions`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_dashboard_section_id: myContractSectionId
//             }
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const repeatBranch = (original_cs_id ) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSection/repeatBranch`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {
//                 original_cs_id: original_cs_id
//             }}
//     )
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log("submission fields")
//             console.log(source_section_id, destination_section_id, minimum_cdp, maximum_cdp)
//             console.log(error.config);
//         })
//
//
// export const repeatBranchFresh = (original_cs_id ) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSection/repeatBranchFresh`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {
//                 original_cs_id: original_cs_id
//             }}
//     )
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log("submission fields")
//             console.log(source_section_id, destination_section_id, minimum_cdp, maximum_cdp)
//             console.log(error.config);
//         })
//
// export const reinsertBranch = (original_cs_id ) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSection/reinsertBranch`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {
//                 original_cs_id: original_cs_id
//             }}
//     )
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log("submission fields")
//             console.log(source_section_id, destination_section_id, minimum_cdp, maximum_cdp)
//             console.log(error.config);
//         })
//
//
// export const regrowBranch = (original_cs_id ) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSection/regrowBranch`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {
//                 original_cs_id: original_cs_id
//             }}
//     )
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log("submission fields")
//             console.log(original_cs_id)
//             console.log(error.config);
//         })
//
//
// export const trimBranch = (original_cs_id ) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSection/trimBranch`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {
//                 original_cs_id: original_cs_id
//             }}
//     )
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             // console.log("submission fields")
//             // console.log(source_section_id, destination_section_id, minimum_cdp, maximum_cdp)
//             console.log(error.config);
//         })
//
//
// export const updateCsTreeByContractId = (contractId ) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSection/updateCsTreeByContractId`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {
//                 contract_id: contractId
//             }}
//     )
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             // console.log("submission fields")
//             // console.log(source_section_id, destination_section_id, minimum_cdp, maximum_cdp)
//             console.log(error.config);
//         })
//
// export const updateContractSectionContents = (contractSectionId, contents) => {
//     return axios.patch(
//         `${BASE_URL}/api/contramatic/contractSection/${contractSectionId}/contents`,
//         { contents }
//     );
// };
//
//
// export const updateLineItem = (contractSectionId ) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSection/updateLineItem`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {
//                 my_section_id: contractSectionId
//             }}
//     )
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             // console.log("submission fields")
//             // console.log(source_section_id, destination_section_id, minimum_cdp, maximum_cdp)
//             console.log(error.config);
//         })
//
//
// export const getHelperData = (my_contract_section_id ) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSection/helperData`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {
//                 my_contract_section_id: my_contract_section_id
//             }}
//     )
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             // console.log("submission fields")
//             // console.log(source_section_id, destination_section_id, minimum_cdp, maximum_cdp)
//             console.log(error.config);
//         })